import React, { ReactElement, useState, useEffect } from 'react';
import Link from 'components/UI/Link';
import ScheduleAppointmentCta from './ScheduleAppointmentCta';
import { IPageLocationFields } from 'types/contentful';
import NewLocationDetailsCard from './NewLocationDetailsCard';
import AccordianBanner from './AccordianBanner';
import type { Entry } from 'contentful';

interface NearbyClinicCardProps {
  locations: Entry<IPageLocationFields>[];
}

export default function NearbyClinicCard({ locations }: NearbyClinicCardProps): ReactElement {
  const [isLargeScreen, setIsLargeScreen] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleAccordion = (): void => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isLargeScreen) {
      setIsOpen(true);
    }
  }, [isLargeScreen]);

  useEffect(() => {
    const updateScreenSize = (): void => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => {
      window.removeEventListener('resize', updateScreenSize);
    };
  }, []);

  return (
    <div className="ecp-my px-site-component py-10 md:py-20">
      <AccordianBanner
        onClick={toggleAccordion}
        isOpen={isOpen}
        isLargeScreen={isLargeScreen}
        header={'Nearby Eye Clinics'}
      />

      {isOpen && (
        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-6">
          {locations.slice(0, 3).map((location, index) => (
            <div
              key={index}
              className="flex flex-col justify-between bg-neutral px-4 py-4 md:px-5 md:py-5"
            >
              <div className="w-full">
                <NewLocationDetailsCard key={index} location={location.fields} showLocationIcon />
              </div>
              <div className="mt-6 w-full text-center">
                <ScheduleAppointmentCta
                  location={location.fields}
                  colorScheme="Primary"
                  wrapperClasses="block"
                  classNames="flex w-full button-text text-primary-actual remove-cta-padding justify-center"
                  text="Schedule An Eye Exam"
                />
                <Link slug={`locations/${location.fields.slug}`}>
                  <a className="mt-5 block text-primary-actual">View location details</a>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
